// Keep this list aligned with the future profile payload. Titles and source
// notes deliberately stay chart-specific: a style transfer must not overwrite
// the content that distinguishes one comparison variant from another.
export const PORTABLE_CANVAS_THEME_FIELDS = [
  'primaryColor',
  'secondaryColor',
  'backgroundColor',
  'textColor',
  'labelColor',
  'markOpacity',
  'lineStrokeScale',
  'fontFamily',
  'labelHandlingMode',
  'labelOverflowStrategy',
  'labelFontScale',
  'labelOutline',
  'labelShowEveryNth',
  'labelShowFullOnHover',
  'labelMaxCharacters',
  'palette',
]

export function getPortableCanvasTheme(theme = {}) {
  return PORTABLE_CANVAS_THEME_FIELDS.reduce((portableTheme, field) => {
    if (theme[field] === undefined) return portableTheme
    return { ...portableTheme, [field]: theme[field] }
  }, {})
}

/**
 * Applies one chart's portable appearance to selected chart objects only.
 * Mapping, chart type, title, source, aspect ratio, and visual options remain
 * owned by each chart object.
 */
export function applyCanvasThemeToSelection(objects, sourceId, targetIds) {
  const source = objects.find((object) => object.id === sourceId && object.kind === 'chart')
  if (!source) return objects

  const targetIdSet = new Set(targetIds)
  const portableTheme = getPortableCanvasTheme(source.brandTheme)
  if (!targetIdSet.size || !Object.keys(portableTheme).length) return objects

  return objects.map((object) => {
    if (object.kind !== 'chart' || !targetIdSet.has(object.id)) return object
    return {
      ...object,
      brandTheme: { ...object.brandTheme, ...portableTheme },
      // A chart's color scale is a normal, serializable Lugsail visual option.
      // It is part of its appearance, so transfer it without touching mappings,
      // content, aspect ratio, or other chart-specific options.
      visualOptions: source.visualOptions?.colorScale
        ? { ...object.visualOptions, colorScale: source.visualOptions.colorScale }
        : object.visualOptions,
    }
  })
}
